import * as type from './mutation-types'
import * as API from './api'
import { ajax } from '@/utils/fetch'

// 修改平台邮箱账号密码
export const changePwd = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CHANGEPWD_REQUEST, data)
        // http 请求
    return ajax.post(
        API.changePwd, {
            commit
        },
        data,
        type.CHANGEPWD_RECEIVE
    )
};
// 引继码生成
export const inherit = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.INHERIT_REQUEST, data)
        // http 请求
    return ajax.post(
        API.inherit, {
            commit
        },
        data,
        type.INHERIT_RECEIVE
    )
};
// 发送联系邮箱验证码
export const sendEmailCode = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.SENDEMAILCODE_REQUEST, data)
        // http 请求
    return ajax.post(
        API.sendEmailCode, {
            commit
        },
        data,
        type.SENDEMAILCODE_RECEIVE
    )
};
// 验证联系邮箱验证码
export const checkEmailCode = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CHECKEMAILCODE_REQUEST, data)
        // http 请求
    return ajax.post(
        API.checkEmailCode, {
            commit
        },
        data,
        type.CHECKEMAILCODE_RECEIVE
    )
};
// 获取用户消费记录
export const getPOrderList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETPORDERLIST_REQUEST, data)
        // http 请求
    return ajax.post(
        API.getPOrderList, {
            commit
        },
        data,
        type.GETPORDERLIST_RECEIVE
    )
};
// 获取用户平台币充值记录
export const getROrderList = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETRORDERLIST_REQUEST, data)
        // http 请求
    return ajax.post(
        API.getROrderList, {
            commit
        },
        data,
        type.GETRORDERLIST_RECEIVE
    )
};
// 平台游客账号绑定平台邮箱账号
export const relateEmail = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.RELATEEMAIL_REQUEST, data)
        // http 请求
    return ajax.post(
        API.relateEmail, {
            commit
        },
        data,
        type.RELATEEMAIL_RECEIVE
    )
};
// 第三方账号升级平台邮箱账号
export const upgradeEmail = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.UPGRADEEMAIL_REQUEST, data)
        // http 请求
    return ajax.post(
        API.upgradeEmail, {
            commit
        },
        data,
        type.UPGRADEEMAIL_RECEIVE
    )
};
// 平台账号登陆领取积分入口
export const integralAward = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.INTAWARD_REQUEST, data)
        // http 请求
    return ajax.post(
        API.integralAward, {
            commit
        },
        data,
        type.INTAWARD_RECEIVE
    )
};
// 获取三方支付登录码
export const getLogCode = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.GETLOGCODE_REQUEST, data)
        // http 请求
    return ajax.postPay(
        API.getLogCode, {
            commit
        },
        data,
        type.GETLOGCODE_RECEIVE
    )
};
// 获取三方支付登录码白名单
export const checkWhitelist = ({ commit }, data) => {
    // http 请求前分发action
    commit(type.CHECKWHITELIST_REQUEST, data)
        // http 请求
    return ajax.get(
        API.checkWhitelist, {
            commit
        },
        data,
        type.CHECKWHITELIST_RECEIVE
    )
};